import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";

export function setModoTela(modo, registro = {}) {
  return {
    type: "ERRO_INTEGRACAO_MODO_TELA",
    payload: {
      modo: modo,
      registro: registro,
    },
  };
}

export function getLista({ tipo, tipo_erro }) {
  return (dispatch, getState) => {
    axios
      .get(
        `${consts.API_URL}/integracaoLog/erros?tipo=${tipo}&tipo_erro=${tipo_erro}`
      )
      .then((resp) => {
        dispatch({
          type: "ERRO_INTEGRACAO_LISTADO",
          payload: resp,
        });
      })
      .catch((ex) => {
        console.log(ex);
      });
  };
}

export function setCadastroCorrigido(params) {
  const { item, callback } = params;
  return async (dispatch, getState) => {
    try {
      // console.log(item)
      if (item.tipo === "SÓCIO") {

        await axios.put(`${consts.API_URL}/integracaoLog/socio/corrigir`, item)
      } else if (item.tipo === "CONJUGE") {

        await axios.put(`${consts.API_URL}/integracaoLog/conjuge/corrigir`, item)
      }

      setSuccess("Registro reenviado com sucesso")
      return {}
    } catch (erro) {
      setErroAPI(erro)
    } finally {
      if (callback) callback();
    }
  }
}
